<template>
  <div>
    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              MY JOB SCHEDULE
            </p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "../../../components/Cards/Card.vue";

export default {
  name: "AuthoritiesSchedule",

  components: {
    Card,
  },

  data() {
    return {};
  },
  methods: {},
  created() {},
  computed: {},
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}
</style>
